module.exports = __webpack_public_path__ + "img/Getting-Crafty-with-Chemistry.a77ec2f7.png";